export default "__VITE_ASSET__CaYSKOgN__"